module.exports = __webpack_public_path__ + "media/landing_page/why-shoppers-pp-2-8057c4ea.jpg";